// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages--l6H"};